// Author lidongxu
// Date 2024-03-05 11:16:59

import * as model from "@/model/sithMes/stool/SithMesStoolPrApplicationTypeConfigModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolPrApplicationTypeConfig(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
        selectRowsToItems: function (row) {
            return {value: row.id, text: row.name}
        },
    })
    .buildStore()
